// Mention helpers shared by the web comment composer and comment rendering.
// Same rules as ante-mobile-user utils/AntMentionText.js so a comment tagged on one
// platform reads and notifies identically on the other.

export function mentionLabel(item) {
    return (item && (item.label || item.mention_text || item.display_name)) || '';
}

export function mentionKey(item) {
    return (item && item.key) || 'user:' + (item && item.code);
}

export function mentionTarget(item) {
    return Object.assign({}, (item && item.mention_target) || { type: 'user', value: item && item.code }, { label: mentionLabel(item) });
}

// Positions of "@label" tokens in a draft, one span per whole-word token, no overlaps.
export function mentionSpans(text, items) {
    var spans = [];
    (items || []).forEach(function (item) {
        var label = mentionLabel(item);
        if (!label) return;
        var token = '@' + label;
        var start = text.indexOf(token);
        while (start !== -1) {
            var before = text[start - 1];
            var after = text[start + token.length];
            if ((!before || /\s/.test(before)) && (!after || /[\s.,!?;:()[\]{}]/.test(after))) {
                spans.push({ start: start, end: start + token.length, label: label, item: item });
            }
            start = text.indexOf(token, start + token.length);
        }
    });
    spans.sort(function (a, b) {
        return a.start - b.start || b.end - a.end;
    });
    return spans.filter(function (span, index) {
        return !spans.slice(0, index).some(function (previous) {
            return previous.end > span.start;
        });
    });
}

// Stored spans from the server (mention_entities); only trusted when they still match the text.
export function storedMentionSpans(text, value) {
    if (typeof value === 'string') {
        try {
            value = JSON.parse(value);
        } catch (e) {
            return [];
        }
    }
    if (!Array.isArray(value) || !text) return [];
    var spans = value
        .filter(function (item) {
            return (
                item &&
                Number.isInteger(item.start) &&
                Number.isInteger(item.end) &&
                item.start >= 0 &&
                item.end > item.start &&
                text.slice(item.start, item.end) === '@' + item.label
            );
        })
        .sort(function (a, b) {
            return a.start - b.start;
        });
    return spans.filter(function (span, index) {
        return !spans.slice(0, index).some(function (previous) {
            return previous.end > span.start;
        });
    });
}

// The "@query" being typed right before the caret, or null.
export function activeMentionQuery(text, caret, selected) {
    var prefix = String(text || '').slice(0, caret);
    var match = prefix.match(/(?:^|\s)@([^@\n]{0,60})$/);
    if (!match) return null;
    var query = match[1];
    var alreadyTagged = (selected || []).some(function (item) {
        return query.indexOf(mentionLabel(item) + ' ') === 0;
    });
    return alreadyTagged ? null : query;
}
